import { getHighlightClasses } from "@/lib/get-tokens-highlights";
import { cn } from "../lib/utils";

// WARNING
// new token colors or classes require `npm run build` or `npm run gen-colors`
// this is a tailwind dynamic class issue
// https://tailwindcss.com/docs/detecting-classes-in-source-files#safelisting-classes

interface TokenProps {
  variant?: "xs" | "sm" | "md" | "lg";
  assetId?: number | bigint;
  className?: string;
  glowing?: boolean;
}

const sizeMap = {
  xs: {
    size: 32,
    shadowSize: "shadow-[0_0_15px_5px]",
  },
  sm: {
    size: 40,
    shadowSize: "shadow-[0_0_20px_5px]",
  },
  md: {
    size: 64,
    shadowSize: "shadow-[0_0_25px_5px]",
  },
  lg: {
    size: 96,
    shadowSize: "shadow-[0_0_30px_5px]",
  },
  xl: {
    size: 256,
    shadowSize: "shadow-[0_0_40px_5px]",
  },
};

export function SingleToken({
  variant = "md",
  assetId = 0, // 0 is ALGO
  className = "",
  glowing = true,
}: TokenProps) {
  const { size, shadowSize } = sizeMap[variant];

  const imageUrl =
    assetId === 0
      ? `/assets/token-icons/0-centered.png`
      : `/assets/token-icons/${assetId}.png`;

  const shadowClass = getHighlightClasses(assetId, "shadow", "/70");
  const borderClass = getHighlightClasses(assetId, "border");

  return (
    <div
      className={cn("relative", className)}
      style={{ width: size, height: size }}
    >
      <div
        className={cn(
          "absolute inset-0 rounded-full",
          // `group-hover:${shadowSize}`, //  TODO not working? listing card has group on top
          // `group-hover:${shadowClass}`,
          glowing ? shadowSize : "",
          glowing ? shadowClass : "",
          glowing && "animate-[pulse_3s_linear_infinite]"
        )}
      />
      <div
        className={cn(
          `relative rounded-full overflow-hidden bg-gray-100 border`,
          borderClass
        )}
        style={{ width: size, height: size }}
      >
        <div className="absolute inset-0">
          <div
            className="w-full h-full bg-card"
            style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        </div>
      </div>
    </div>
  );
}
